module.exports = __webpack_public_path__ + "img/sharp-50.a91f764c.jpg";